<template>
  <div class="row calculate">
    <div class="col-7 calculate-part">
      <router-view></router-view>
    </div>
    <div class="col-5" v-if="isCardVisible">
      <div class="calculated-card">
        <div class="calculated-card__header d-flex align-items-center justify-content-between p-3">
          <span>
            <span class="calculated-card__header-title">Итог:</span>
            <span class="calculated-card__header-price ml-2">{{ cardPrice }}</span>
            <div class="custom-control custom-checkbox mr-2 ml-1">
              <input id="checkboxSelectAll" type="checkbox" class="custom-control-input" @input="checkAllItems" :checked="isAllChecked">
              <label class="custom-control-label" for="checkboxSelectAll"></label>
            </div>
          </span>
          <div v-if="isAddAgent">
            <button type="button" class="btn btn-outline-primary px-2" @click="removeItemsFromCard" :disabled="checkedCardItems.length === 0">
              <i class="checkAllItemsico ico-delete px-2"></i>
            </button>
            <button type="button" class="btn btn-primary" @click="goToCreateRequest" :disabled="checkedCardItems.length === 0">
              <i class="fa fa-check"></i> создать заявку
            </button>
          </div>
          <div v-else>
            <button type="button" class="btn btn-outline-primary px-2" @click="openPdfOffer" :disabled="checkedCardItems.length === 0">
              <i class="fa fa-file-pdf-o px-2"></i>
            </button>
            <button type="button" class="btn btn-outline-primary px-2" @click="printOffer" :disabled="checkedCardItems.length === 0">
              <i class="ico ico-print px-2"></i>
            </button>
            <button type="button" class="btn btn-outline-primary px-2" @click="removeItemsFromCard" :disabled="checkedCardItems.length === 0">
              <i class="ico ico-delete px-2"></i>
            </button>
            <button type="button" class="btn btn-outline-primary px-2" title="Быстрая сделка" @click="createFastDeal" :disabled="checkedCardItems.length === 0">
              <i class="fa fa-rocket px-2"></i>
            </button>
            <button type="button" class="btn btn-primary" @click="goToCreateTask" :disabled="checkedCardItems.length === 0">
              <i class="fa fa-check"></i> создать задачу
            </button>
          </div>
        </div>
        <div
          class="calculated-card__body pl-2 py-2"
          v-for="(item, index) in basketItems"
          :key="item.id" :title="item.data.printMachineName">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fa fa-angle-down cursor-pointer mr-2" v-if="item.expanded"  @click="() => item.expanded = false" ></i>
              <i class="fa fa-angle-right cursor-pointer mr-2" v-else @click="() => item.expanded = true"></i>
              <div class="custom-control custom-checkbox mr-2">
                <input type="checkbox" :id="'card' + index" :value="item.id" class="custom-control-input" v-model="checkedCardItems">
                <label class="custom-control-label" :for="'card' + index"></label>
              </div>
              <span class="calculated-card__body-title" :title="item.data.name">{{item.data.name}}</span>
            </div>
            <span>
              <span class="calculated-card__body-count">{{item.data.printing}} шт.</span>
              <span class="calculated-card__body-cost">{{(+item.data.cost).toFixed(2)}}</span>
            </span>
          </div>
          <template v-if="item.expanded">
          <div class="calculated-card__details" v-for="(section, index) in item.data.sections" :key="index">
            <template v-if="section.blocks.length > 0">
              <p class="calculated-card__details-section mt-2 mb-0 text-center">{{section.name}}</p>
              <dl class="row my-0" v-for="(block, index) in section.blocks" :key="index">
                <dt class="calculated-card__details-block col-sm-3 my-0 py-0 ">{{block.name}}</dt>
                <dd class="col-sm-9 my-0 py-0">{{block.value}}</dd>
              </dl>
            </template>
          </div>
          </template>
        </div>
      </div>
    </div>
    <div class="fast-deal col-5" v-if="isFastDealVisible">
      <div class="fast-deal__header d-flex align-items-center justify-content-between">
        <div>
          <span class="fast-deal__header-title">Оплатить:</span>
          <span class="fast-deal__header-price ml-2">{{ cardPrice }}</span>
        </div>
        <div>
          <button type="button" class="btn btn-outline-primary px-2" title="Быстрая сделка" @click="cancelFastDeal">
            <i class="fa fa-times px-2"></i>
          </button>
          <button type="button" class="btn btn-primary ml-2" @click="saveFastDeal">
            <i class="fa fa-check px-1"></i>
          </button>
        </div>
      </div>
      <div class="fast-deal__name mt-3">
        <h3>{{fastDealTitle}}</h3>
      </div>
      <div class="fast-deal__transactions mt-3">
        <table class="table fast-deal__transactions-table">
          <thead>
            <tr>
              <th>
                <div class="table-th">Сумма</div>
              </th>
              <th>
                <div class="table-th">Способ оплаты</div>
              </th>
              <th>
                <div class="table-th"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input type="text" class="form-control form-control-sm" @blur="()=> transaction.price = transaction.price.replace(',', '.')" v-model="transaction.price">
              </td>
              <td>
                <select
                class="form-control form-control-sm custom-select py-0 mx-2"
                v-model="transaction.financeAccount"
                >
                  <option value="" selected hidden>Счет ...</option>
                  <option
                      v-for="financeAccount in financeAccounts"
                      :key="financeAccount.name"
                      :value="financeAccount.id"
                      :selected="financeAccount.id === transaction.financeAccount"
                  >{{ financeAccount.name }}
                  </option>
                </select>
              </td>
              <td class="text-center">
                <button type="button" @click="addTransaction" :disabled="!(transaction.financeAccount > 0 && transaction.price > 0)"  class="btn btn-sm btn-primary px-3">
                  <i class="fa fa-check"></i>
                </button>
              </td>
            </tr>
            <tr v-for="transaction in transactions" :key="transaction.id">
              <td>
                <div class="td-content font-weight-bold pl-2">{{transaction.price}}</div>
              </td>
              <td>
                <div class="td-content font-weight-bold pl-2">{{transaction.financeAccountName}}</div>
              </td>
              <td class="text-center">
                <div class="td-content">
                  <button type="button" class="btn btn-sm btn-outline-primary px-3" @click="deleteTransaction(transaction)">
                    <i class="ico ico-delete"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import api from '../../../api'
import roles from '../../../helpers/userRoles'
import moment from 'moment'

const getNewTransaction = () => {
  return {
    price: '',
    financeAccount: '',
    date: moment().format('DD MMM YYYY'),
    description: ''
  }
}

export default {
  name: 'Calculate',
  components: {},
  data: () => {
    return {
      checkedCardItems: [],
      basket: [],
      financeAccounts: [],
      transaction: getNewTransaction(),
      transactions: [],
      isFastDealVisible: false,
      uId: 0,
      printWindow: null
    }
  },
  methods: {
    goToCreateTask () {
      if (this.checkedCardItems.length > 0) {
        this.$router.push(`/add-task-from-calculator?checkedCardItems=${JSON.stringify(this.checkedCardItems)}`)
      }
    },
    goToCreateRequest () {
      if (this.checkedCardItems.length > 0) {
        this.$router.push(`/ad-agent/add-request-from-calculator?checkedCardItems=${JSON.stringify(this.checkedCardItems)}`)
      }
    },
    removeItemsFromCard () {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              api.post.removeFromBasket(this.checkedCardItems)
                .then(() => {
                  this.updateCard()
                })
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    expand (item) {
      item.expanded = true
    },
    printOffer () {
      this.printWindow && this.printWindow.close()
      if (this.checkedCardItems.length === 0) return
      this.printWindow = window.open(`/api/calculator/print-machines/calculating/basket/offer?checked_items[]=${this.checkedCardItems.join('&checked_items[]=')}`, 'Печать КП', 'width=600,height=600')
      const printWindow = this.printWindow
      printWindow.addEventListener('load', function () {
        setTimeout(function () {
          printWindow.print()
        }, 500)
      })
    },
    openPdfOffer () {
      if (this.checkedCardItems.length === 0) return
      const myWindow = window.open(`/api/calculator/print-machines/calculating/basket/offer?checked_items[]=${this.checkedCardItems.join('&checked_items[]=')}`, '_blank')
      myWindow.focus()
    },
    loadFinanceAccounts () {
      api.get.financeAccounts().then((resp) => {
        this.financeAccounts = resp.data.data.finance_accounts
          .filter(x => x.enabled)
          .map(x => {
            return {
              id: x.id,
              name: x.name
            }
          })
      })
    },
    createFastDeal () {
      this.isFastDealVisible = true
      this.transactions = []
    },
    cancelFastDeal () {
      this.isFastDealVisible = false
    },
    async saveFastDeal () {
      const fastDeal = {
        tech_map: this.checkedItems.map(x => x.id),
        name: this.fastDealTitle,
        transactions: this.transactions.map(x => {
          return {
            price: x.price,
            faid: x.faid
          }
        })
      }
      await api.post.createFastDeal(fastDeal)
      this.isFastDealVisible = false
      this.updateCard()
    },
    addTransaction () {
      const newTransaction = {
        id: ++this.uId,
        price: this.transaction.price,
        faid: this.transaction.financeAccount,
        financeAccountName: this.financeAccounts.find(x => x.id === this.transaction.financeAccount).name,
        date: this.transaction.date,
        description: this.transaction.description
      }
      this.transactions.push(newTransaction)
      this.transaction = getNewTransaction()
    },
    deleteTransaction (transaction) {
      const index = this.transactions.findIndex(x => x.id === transaction.id)
      this.transactions.splice(index, 1)
    },
    checkAllItems () {
      if (!this.isAllChecked) {
        this.checkedCardItems = this.basketItems.map(x => x.id)
      } else {
        this.checkedCardItems = []
      }
    },
    ...mapActions({
      updateCard: 'UPDATE_CARD',
      removeFromCard: 'REMOVE_FROM_CARD'
    })
  },
  computed: {
    checkedItems () {
      return this.$store.state.calculatedCard.filter(x => this.checkedCardItems.indexOf(x.id) >= 0)
    },
    cardPrice () {
      return this.checkedItems.length > 0
        ? this.checkedItems
          .map(x => +x.data.cost)
          .reduce((a, b) => a + b)
          .toFixed(2)
        : 0
    },
    isCardVisible () {
      return this.$store.state.calculatedCard.length > 0 && !this.isFastDealVisible
    },
    basketItems () {
      return this.$store.state.calculatedCard.map(x => {
        return { ...x, expanded: false }
      })
    },
    fastDealTitle () {
      return this.checkedItems.length > 0
        ? this.checkedItems.map(x => x.data.name).join(' + ')
        : ''
    },
    isAddAgent () {
      return this.$store.getters.role === roles.adAgent
    },
    isAllChecked () {
      return this.basketItems.length === this.checkedCardItems.length
    }
  },
  watch: {
    basketItems (newItems) {
      this.basket = newItems
    }
  },
  created () {
    this.updateCard()
    if (!this.isAddAgent) {
      this.loadFinanceAccounts()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'Калькулятор')
    })
  }
}
</script>

<style lang="scss" scoped>
.calculated-card {
  background-color: #f3f5f5;

  &__body + &__body,
  &__header + &__body {
    border-top: 1px solid #dbe1e5;
  }

  &__header-title {
    font-size: 16px;
    font-weight: 700;
    color: #918a8a;
  }

  &__header-price {
    font-size: 24px;
    font-weight: 700;
    color: rgb(34, 174, 127);
  }

  &__body-title,
  &__body-cost,
  &__body-count {
    font-size: 16px;
    font-weight: 700;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__body-title{
     max-width: 250px;
   }

  &__body-cost {
    display: inline-block;
    width: 60px;
  }

  &__body-count {
    display: inline-block;
    width: 60px;
  }

  &__body-remove {
    font-size: 16px;
    cursor: pointer;
    color: #918a8a;
  }

  &__details{
    &-section{
      font-size: 15px;
      font-weight: 700;
    }

    &-block{
      color: #918a8a;
      font-size: 13px;
    }
  }
}

.fast-deal {
  &__header-title {
    font-size: 16px;
    font-weight: 700;
    color: #918a8a;
  }

  &__header-price {
    font-size: 24px;
    font-weight: 700;
    color: rgb(34, 174, 127);
  }

  &__transactions-table {
    min-width: auto;
  }
}
</style>
